import React, { createContext, useState, useEffect, useContext } from "react";

// Create the context
const UserContext = createContext();

// Read the stored user synchronously so the very first render already has it.
// A useEffect-based load runs *after* first render, which left route guards
// like AdminGate seeing `user === null` for one tick and redirecting away
// before the real user ever loaded.
const loadStoredUser = () => {
  try {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  } catch {
    localStorage.removeItem("user");
    return null;
  }
};

// Provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(loadStoredUser);

  // Update localStorage when user changes
  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  }, [user]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};


export const useUser = () => useContext(UserContext);